import { http, HttpResponse } from 'msw'

interface MockUpdateSlipCostumizationPathParams {
  alphaId: string
  slipCostumizationAlphaId: string
}

interface MockUpdateSlipCostumizationBody {
  paymentMethodId: string // BILLING, CARD, DIRECT
  logoImage: string
  customerId: number
  sectionId: string
  text: string
  data: {
    invoice: {
      recipient: string // GUEST_DATA, AGENCY_DATA, SALS_POINT_DATA, CUSTOMER_DATA
      data: {
        corporateName: string
        taxpayerType: string
        taxpayerId: string
        address: string
        observation: string
      }
    }
    documentation: {
      recipient: string // TO_GUEST, TO_AGENCY, TO_SALES_POINT, TO_CUSTOMER
      data: {
        corporateName: string
        taxpayerType: string
        taxpayerId: string
        address: string
        observation: string
      }
    }
  }
  active: boolean
}

export const mockUpdateSlipCostumization = http.patch<
  MockUpdateSlipCostumizationPathParams,
  MockUpdateSlipCostumizationBody
>(
  '/my-business/api/agency/v1/*/:alphaId/slip-customization/:slipCostumizationAlphaId',
  () => {
    return HttpResponse.json(null, { status: 200 })
  },
)
